import React,{useState} from 'react'
import {useForm} from 'react-hook-form'
import clinicService from '../../services/clinic.service'

const FeedbackUnsat = ({clinic,patientID,patientUUID}) => {
   
    const [showThankyou,setShowThankyou] = useState(false)
    const [showForm,setShowForm] = useState(true)
    const {register,handleSubmit,formState:{errors}}=useForm();

    const onSubmit = (data)=>{
      //  console.log(data)
        data["clinicID"] = clinic.ID;
        data["patientID"] = patientID;
        data["patientUUID"] = patientUUID
       // console.log(data)
        clinicService.addComment(clinic.ID,data)
        .then(res=>{
            setShowForm(false)
            setShowThankyou(true)
        })
        .catch(err=>console.log(err))
    }
    const handleCancle = ()=>{
        window.location.reload();
    }
    return ( 
        <>
        {showForm &&
         <div className="container mt-4">
                    <div className="row justify-content-center">
                        <div className="col-md-6">
                           <div className="card border-light text-bg-light text-center">
                                    <div className="card-body">
                                        <h4 className="m-3">Please comment what could we have done better? </h4>
                                        <form onSubmit={handleSubmit(onSubmit)}>
                                               <div className="row">
                                                    <div className="col">
                                                        <input 
                                                            type="text" 
                                                            placeholder='First Name' 
                                                            className="form-control"
                                                            {...register("firstName")}
                                                            />
                                                    </div>
                                                    <div className="col">
                                                        <input 
                                                            type="text" 
                                                            placeholder='Last Name' 
                                                            className="form-control" 
                                                            {...register("lastName")}
                                                            />
                                                    </div>    
                                                </div> 
                                                
                                                <div className="row mt-3">
                                                    <div className="col">
                                                       <textarea 
                                                            name="" 
                                                            placeholder='Comment*' 
                                                            rows="6" 
                                                            className="form-control"
                                                            {...register("notes",{required:true})}
                                                            ></textarea> 
                                                            {errors.notes && "Please provide comment."}
                                                    </div>
                                                </div>
                                                <div className="row mt-3">
                                                    <input type="hidden"
                                                        {...register("patientID")}/>
                                                      <input type="hidden"
                                                        {...register("patientUUID")}/>
                                                          <input type="hidden"
                                                        {...register("clinicID")}/>
                                                    <div className="col">
                                                        <button className="btn btn-secondary me-2" type="submit">Submit</button>
                                                        <button className="btn btn-secondary" onClick={()=>handleCancle()}>Cancel</button>
                                                    </div>
                                                </div>
                                        </form>                               
                                    </div>
                            </div>
                        </div>
                        
                    </div>
                </div> 
            }

            {showThankyou && 
                 <div className="container mt-4">
                 <div className="row justify-content-center">
                     <div className="col-md-6">
                        <div className="card border-light text-bg-light text-center">
                                 <div className="card-body">
                                     <h4 className="m-3"> Thank you for your feedback. </h4>
                                </div>
                        </div>
                    </div>
                </div>
                </div>
            }
        </>
     );
}
 
export default FeedbackUnsat;